import React, { useCallback, useEffect, useState } from "react";
// import { Button } from "react-bootstrap";
import BootStrapTable from "react-bootstrap-table-next";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BackButton from "../../components/Form/BackButton";
import { API, defaultLimitPagination, get } from "../../config";
import {
  formatMobile,
  formatName,
  formatNumber,
  formatPhone,
} from "../common/Misc";
import Pagination from "../common/Pagination";
import Spin from "../common/Spin";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faDownload,
  faEye,
  faXmarkCircle,
} from "@fortawesome/free-solid-svg-icons";
import { Modal } from "react-bootstrap";
import CustomTooltip from "../common/CustomTooltip";
// import { debounce } from "lodash";

const SubscriptionsForAdmin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  // const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [subscriptionsList, setSubscriptionList] = useState([]);
  const [subscriptionLoading, setSubscriptionLoading] = useState(false);
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  // const [searchParam, setSearchParam] = useState(search || "");
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  const [showInvoice, setShowInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState([]);
  const [invoiceLimit, setInvoiceLimit] = useState(defaultLimitPagination);
  const [invoicePage, setInvoicePage] = useState(1);
  const [invoiceTotal, setInvoiceTotal] = useState();
  const [invoiceFrom, setInvoiceFrom] = useState();
  const [invoiceTo, setInvoiceTo] = useState();
  const [loading, setLoading] = useState(false);

  const fetchInvoice = useCallback(
    async (passLimit, passPage, id) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.GET_SUBSCRIPTION_FOR_ADMIN}/${id}?page=${
            passPage ? passPage : invoicePage ? invoicePage : 1
          }&limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }`
        );
        setInvoiceData(data?.data?.data);
        setLoading(false);
        setInvoiceLimit(data?.data?.per_page);
        setInvoicePage(data?.data?.current_page);
        setInvoiceTotal(data?.data?.total);
        setInvoiceFrom(data?.data?.from);
        setInvoiceTo(data?.data?.to);
      } catch (e) {
        if (e?.response?.data?.errors) {
          Object.keys(e?.response?.data?.errors).forEach((key) => {
            toast.error(e?.response?.data?.errors[key][0]);
          });
          setLoading(false);
        } else {
          toast.error(e?.message);
          setLoading(false);
        }
        setInvoiceData([]);
        setInvoiceLimit(defaultLimitPagination);
        setInvoiceTotal();
        setInvoiceFrom();
        setInvoiceTo();
        setInvoicePage(1);
        setLoading(false);
      }
    },
    [invoicePage, limit]
  );

  const toggleInvoiceModal = (id) => {
    if (id) {
      fetchInvoice(invoiceLimit, invoicePage, id);
    }
    setShowInvoice(!showInvoice);
  };

  const handleUpdateInvoiceLimit = (e) => {
    const invoiceLimit = e.target.value;
    setInvoiceLimit(invoiceLimit);
    setInvoicePage(1);
    fetchInvoice(invoiceLimit, 1);
  };

  const handleChangeInvoicePage = (page) => {
    setInvoicePage(page);
    fetchInvoice(invoiceLimit, page);
  };

  // *API Call for Download .ABA File - Start
  const downloadLetter = async (path) => {
    try {
      if (path) {
        var a = document.createElement("a");
        a.href = path;
        var file = path.split("/");
        a.setAttribute("download", file[file.length - 1] || "new_invoice.pdf");
        document.body.appendChild(a);
        a.click();
        a.remove();
      } else {
        toast.error("File is not exist");
      }
    } catch (e) {
      const errors = e.response?.data?.errors;
      Object.keys(errors).forEach((key) => {
        toast.error(errors[key][0]);
      });
    }
  };

  // *API Call for Subscription User in Admin - Start
  const fetchSubscriptions = useCallback(
    async (passLimit, passPage) => {
      try {
        setSubscriptionLoading(true);
        const { data } = await get(
          `${API.GET_SUBSCRIPTION_FOR_ADMIN}?limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&sort_column=${
            sortField ? sortField : ""
          }&sort_order=${sortOrder ? sortOrder : ""}`
        );
        setSubscriptionLoading(false);
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        const subscriptionsList = data.data.data;
        setSubscriptionList(subscriptionsList);
        return data.data;
      } catch (error) {
        setSubscriptionList([]);
        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
          setSubscriptionLoading(false);
        } else {
          toast.error(error?.message);
          setSubscriptionLoading(false);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sortOrder, sortField]
  );

  useEffect(() => {
    fetchSubscriptions();
  }, [fetchSubscriptions]);
  // *API Call for Subscription User in Admin - End

  // *Subscription User Table Row and Column Generation, Filtering and Sorting of Record - Start
  const subscriptionsGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: subscriptionsList[i]?.id,
        name: formatName(
          subscriptionsList[i]?.user?.first_name,
          subscriptionsList[i]?.user?.last_name
        ),
        email: subscriptionsList[i]?.user?.email
          ? subscriptionsList[i]?.user?.email
          : "",
        phone: subscriptionsList[i]?.user?.phone
          ? formatPhone(subscriptionsList[i]?.user?.phone)
          : "-",
        mobile: subscriptionsList[i]?.user?.mobile
          ? formatMobile(subscriptionsList[i]?.user?.mobile)
          : "-",
        project_name: subscriptionsList[i]?.builder_project?.project_name
          ? subscriptionsList[i]?.builder_project?.project_name
          : "-",
        // role: subscriptionsList[i]?.user?.role?.name
        //   ? subscriptionsList[i]?.user?.role?.name
        //   : "-",
        price: subscriptionsList[i]?.price
          ? `$${formatNumber(Number(subscriptionsList[i]?.price))}`
          : "$0.00",
        tax_price: subscriptionsList[i]?.tax_price
          ? `$${formatNumber(Number(subscriptionsList[i]?.tax_price))}`
          : "$0.00",
        total: `$${formatNumber(
          Number(
            Number(subscriptionsList[i]?.price) +
              Number(subscriptionsList[i]?.tax_price)
          )
        )}`,

        subscription_start_date: subscriptionsList[i]?.subscription_start_date
          ? subscriptionsList[i]?.subscription_start_date
              .split("-")
              .reverse()
              .join("-")
          : "-",
        subscription_end_date: subscriptionsList[i]?.subscription_end_date
          ? `${subscriptionsList[i]?.subscription_end_date
              .split("-")
              .reverse()
              .join("-")}`
          : "-",
        status: (
          <div className="action-center">
            <span>
              {subscriptionsList[i]?.status === 0 ? (
                <FontAwesomeIcon icon={faXmarkCircle} className="rag-red" />
              ) : (
                <FontAwesomeIcon icon={faCheckCircle} className="rag-green" />
              )}
            </span>{" "}
          </div>
        ),
        action: (
          <FontAwesomeIcon
            title="View Invoices"
            onClick={() => toggleInvoiceModal(subscriptionsList[i]?.id)}
            icon={faEye}
            size="1x"
            className="admin-registered-invoice-action"
          />
        ),
      });
    }
    return items;
  };
  const subscriptions = subscriptionsGenerator(subscriptionsList?.length);

  useEffect(() => {
    navigate(
      `/admin/subscriptions?limit=${
        limit ? limit : defaultLimitPagination
      }&page=${page ? page : 1}&sort_column=${
        sortField ? sortField : ""
      }&sort_order=${sortOrder ? sortOrder : ""}`,
      {
        replace: true,
      }
    );
  }, [navigate, limit, page, sortField, sortOrder]);

  const columns = [
    {
      dataField: "name",
      text: "Name",
    },
    {
      dataField: "email",
      text: "Email",
    },
    {
      dataField: "phone",
      text: "Phone No.",
      style: {
        width: "8%",
      },
    },
    {
      dataField: "mobile",
      text: "Mobile No.",
      style: {
        width: "8%",
      },
    },
    {
      dataField: "project_name",
      text: "Project Name",
      style: {
        width: "15%",
      },
    },
    // {
    //   dataField: "role",
    //   text: "Role",
    //   style: {
    //     width: "8%"
    //   }
    // },
    {
      dataField: "price",
      text: "Price (Exc. GST)",
    },
    {
      dataField: "tax_price",
      text: "Tax",
    },
    {
      dataField: "total",
      text: "Total",
    },
    {
      dataField: "subscription_start_date",
      text: "Start Date",
    },
    {
      dataField: "subscription_end_date",
      text: "End Date",
    },
    {
      dataField: "status",
      text: "Status",
      headerStyle: {
        textAlign: "center",
      },
    },
    {
      dataField: "action",
      text: "Action",
      className: "text-center",
      style: { width: "70px", textAlign: "center" },
      headerStyle: {
        textAlign: "center",
      },
    },
  ];

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC"
      );
    }
  };

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchSubscriptions(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchSubscriptions(limit, page);
  };
  // *Subscription User Table Row and Column Generation, Filtering and Sorting of Record - End

  const invoicesGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: invoiceData[i]?.id,
        invoice_date: invoiceData[i]?.effectiveAt
          ? invoiceData[i]?.effectiveAt
          : "-",
        subtotal: invoiceData[i]?.subtotal
          ? `$${formatNumber(invoiceData[i]?.subtotal)}`
          : "$0.00",
        totalTaxAmount: invoiceData[i]?.totalTaxAmount
          ? `$${formatNumber(invoiceData[i]?.totalTaxAmount)}`
          : "$0.00",
        totalDiscountAmount: invoiceData[i]?.totalDiscountAmount
          ? `$${formatNumber(invoiceData[i]?.totalDiscountAmount)}`
          : "$0.00",
        totalAmount: Number(
          Number(
            Number(invoiceData[i]?.subtotal) +
              Number(invoiceData[i]?.totalTaxAmount)
          ) - Number(invoiceData[i]?.totalDiscountAmount)
        )
          ? `$${formatNumber(
              Number(
                Number(
                  Number(invoiceData[i]?.subtotal) +
                    Number(invoiceData[i]?.totalTaxAmount)
                ) - Number(invoiceData[i]?.totalDiscountAmount)
              )
            )}`
          : "$0.00",
        action: (
          <>
            <CustomTooltip message={"Download"}>
              <FontAwesomeIcon
                icon={faDownload}
                size="1x"
                onClick={() => {
                  downloadLetter(invoiceData[i]?.invoicePdf);
                }}
              />
            </CustomTooltip>
            <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
            <CustomTooltip message={"View Invoice"}>
              <FontAwesomeIcon
                icon={faEye}
                size="1x"
                onClick={() => {
                  window.open(
                    invoiceData[i]?.hostedInvoiceUrl,
                    "_blank" // <- This is what makes it open in a new window.
                  );
                }}
              />
            </CustomTooltip>
          </>
        ),
      });
    }
    return items;
  };
  const invoiceDatas = invoicesGenerator(invoiceData?.length);

  const invoiceColumn = [
    {
      dataField: "invoice_date",
      text: "Invoice Date",
    },
    {
      dataField: "subtotal",
      text: "Amount",
    },
    {
      dataField: "totalTaxAmount",
      text: "GST",
    },
    {
      dataField: "totalDiscountAmount",
      text: "Discount",
    },
    {
      dataField: "totalAmount",
      text: "Total Amount",
    },
    {
      dataField: "action",
      text: "Action",
      className: "text-center",
      style: { width: "127px", textAlign: "center" },
      headerStyle: {
        textAlign: "center",
      },
    },
  ];

  return (
    <div className="cms-page">
      <div className="page-content-block">
        <div className="full-content-block">
          <h1 className="page-title">
            <BackButton />
            Subscriptions
          </h1>
          <div className="content-details">
            {/* <div className="table-top-btn">
              <div className="search-section"></div>
              <div className="table-btn">
                <Button variant="primary">Add New</Button>
              </div>
            </div> */}
            <div className="custom-table">
              {subscriptionLoading && <Spin />}
              <BootStrapTable
                keyField="id"
                remote
                data={subscriptions}
                columns={columns}
                onTableChange={handleTableChange}
                noDataIndication="No Data Found"
              />

              <Pagination
                total={total}
                limit={parseInt(limit)}
                currentPage={page}
                updateLimit={handleUpdateLimit}
                updatePage={handleChangePage}
                from={from}
                to={to}
              />
            </div>
          </div>
        </div>
      </div>
      {showInvoice && (
        <Modal
          size="lg"
          show={showInvoice}
          onHide={toggleInvoiceModal}
          dialogClassName="larg-popup journal-modal review-popup small-review doc-variations"
          aria-labelledby="contained-modal-title-vcenter"
          className="project-section"
          centered
        >
          <Modal.Header closeButton>Invoice List</Modal.Header>
          <Modal.Body style={{ padding: "15px 15px 15px 15px" }}>
            <>
              {loading && <Spin />}
              <div>
                <BootStrapTable
                  keyField="key"
                  data={invoiceDatas}
                  columns={invoiceColumn}
                  noDataIndication="No Data Found"
                />
                <Pagination
                  total={invoiceTotal}
                  limit={parseInt(invoiceLimit)}
                  currentPage={invoicePage}
                  updateLimit={handleUpdateInvoiceLimit}
                  updatePage={handleChangeInvoicePage}
                  from={invoiceFrom}
                  to={invoiceTo}
                />
              </div>
            </>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default SubscriptionsForAdmin;
